/* eslint-disable comma-dangle */
import api from '@/api';
import {
  CONFLICT,
  NOT_ACCEPTABLE,
  NOT_FOUND,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY
} from '../../enums/errorEnums';

const baseAPI = `${process.env.VUE_APP_BASE_API}/Jobs`;
const HANDLED_ERRORS = [NOT_ACCEPTABLE, CONFLICT, UNPROCESSABLE_ENTITY, UNAUTHORIZED, NOT_FOUND];

const errorValidate = (response) => {
  let errors = null;
  const { status } = response;

  if (HANDLED_ERRORS.includes(status)) {
    errors = {
      status,
      statusText: response.statusText || response.data.message,
    };
  }

  return errors;
};

export default {
  getAll: async (jobsFilters) => {
    const response = await api.get(baseAPI, { params: jobsFilters });

    const errors = errorValidate(response);

    const { data } = response;

    return {
      data,
      errors,
    };
  },
  getById: async (
    {
      jobId,
      includeCompany = true,
      includeCategory = false
    }
  ) => {
    const response = await api.get(
      `${baseAPI}/${jobId}`,
      {
        params:
        {
          includeCompany,
          includeCategory
        }
      }
    );

    const errors = errorValidate(response);

    const { data } = response;

    return {
      data,
      errors,
    };
  },
  getByCompanyId: async ({ includeIndications = false, companyEmail = '' }) => {
    const response = await api.get(
      `${baseAPI}/by-company`,
      {
        params: {
          companyEmail,
          includeIndications
        }
      }
    );

    const errors = errorValidate(response);

    const { data } = response;

    return {
      data,
      errors,
    };
  },
  create: async ({ payload }) => {
    const response = await api.post(`${baseAPI}`, payload);
    const errors = errorValidate(response);
    const { data } = response;

    return {
      data,
      errors,
    };
  },
  update: async ({ payload, jobId }) => {
    const response = await api.put(`${baseAPI}/${jobId}`, payload);
    const errors = errorValidate(response);
    const { data } = response;

    return {
      data,
      errors,
    };
  },
};
